// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"AdditionalField__mainWrapper___6ImES","bottomIndent":"AdditionalField__bottomIndent___1A64E","label":"AdditionalField__label___3Y8uA"};